import { render, staticRenderFns } from "./ProductCustomerInfo.vue?vue&type=template&id=1567a900&scoped=true"
import script from "./ProductCustomerInfo.vue?vue&type=script&lang=js"
export * from "./ProductCustomerInfo.vue?vue&type=script&lang=js"
import style0 from "./ProductCustomerInfo.vue?vue&type=style&index=0&id=1567a900&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1567a900",
  null
  
)

export default component.exports